import { render, staticRenderFns } from "./DialogProducto.vue?vue&type=template&id=63992607&"
import script from "./DialogProducto.vue?vue&type=script&lang=js&"
export * from "./DialogProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports